/**
 * Created by intellicar-rinas on 4/10/17.
 */
import { schemaTypes, dateFormat } from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor } from "../../../helpers/helperFunctions";
import {
  canShowRangeSwitch,
  flipRange,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import _ from "lodash";
import {
  bulkReqTracker,
  indianNumberFormat,
  stripLoc,
} from "../../../helpers/helperFunctions";
import moment from "moment";
// import mixpanel from "mixpanel-browser";

const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];
  let locationbody = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    let model = vehicleMap[vehiclepath].vehicleModel
      ? vehicleMap[vehiclepath].vehicleModel.model
      : vehicleMap[vehiclepath].vehiclemeta
      ? vehicleMap[vehiclepath].vehiclemeta.model || ""
      : "";

    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let location = eachitem.lat + "," + eachitem.lng;
      let latLngArr = [eachitem.lat, eachitem.lng];
      let pilferageLitres = eachitem.pilferageLitres;
      locationbody.push([eachitem.lat, eachitem.lng]);
      let tankid = eachitem.tankid;
      let fuelprice = indianNumberFormat((eachitem.fuelprice || 0).toFixed(2));
      historyData.push({
        vehicleno,
        model,
        starttime,
        endtime,
        pilferageLitres,
        location,
        latLngArr,
        vehiclepath,
        tankid,
        fuelprice,
      });
    }
  }

  callback(historyData);
  // GeoCodeAPIs.getAddress(locationbody).then(
  //   (resp) => {
  //     for (let idx in historyData) {
  //       historyData[idx].location = resp[idx][1];
  //     }
  //     callback(historyData);
  //   },
  //   (resp) => {
  //     console.log(resp);
  //   }
  // );
};

const getHistory = (schema, data, store) => {
  // mixpanel.track("User Looks For Pilferage Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  clear();
  this.finalData = null;
  let saveState = null;
  let tableStateData = null;
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, false);
    return;
  }
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  if (starttime > endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, false);
    return;
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(this.schema, false);
      // console.log(resp);
      processData(resp, store.vehicleMap, (data) => {
        this.finalData = data;
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: data.vehicle.map((item) => {
        return item.data.vehicleid;
      }),
      starttime: data.starttime.unix() * 1000,
      endtime: data.endtime.unix() * 1000,
    };
    if (window.showNoGpsFixData === true) {
      body.fixqfilter = false;
    }
    ReportAPIs.pilferageReportList(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    window.graphDataErr = "";

    console.log("inside else");
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
    // window.dispatchStoreEvent({
    //   type: actions.GRAPHSET_STATE_CHANGED,
    //   data: 0,
    // });
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(this.schema, false);
    return;
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const getShapes = () => {
  let refuelPoints = [];
  for (let idx in this.refuelHistory) {
    let refule = this.refuelHistory[idx];
    let startindex = _.sortedIndexBy(
      this.fuelLevelHistory,
      { time: refule.starttime },
      "time"
    );
    let endindex = _.sortedIndexBy(
      this.fuelLevelHistory,
      { time: refule.endtime },
      "time"
    );
    refuelPoints.push(this.fuelLevelHistory.slice(startindex, endindex));
  }
  return refuelPoints.map((r) => ({
    strokeOpacity: 1,
    stroke: "#f00",
    axis: 0,
    type: "path",
    data: r,
  }));
};

const onItemClick = (reportItem) => {
  let oneHour = 1000 * 60 * 60;
  let endtime = reportItem.endtime.getTime() + oneHour;
  let starttime = reportItem.starttime.getTime() - oneHour;
  let body = {
    vehicleid: [parseInt(reportItem.vehiclepath, 10)],
    endtime,
    starttime,
  };

  this.selectedVehicle = window.selectedVehicles.filter(
    (d) => d.name === reportItem.vehicleno
  )[0];

  let apis = [
    { api: ReportAPIs.getFuelLevelInfo, body, key: "fuellevel" },
    { api: ReportAPIs.pilferageReportList, body, key: "refuel" },
  ];

  const handleResponse = (resp) => {
    this.fuelLevelHistory = resp[0].resp;
    this.refuelHistory = resp[1].resp[Object.keys(resp[1].resp)[0]];

    if (!Array.isArray(this.fuelLevelHistory) && reportItem.tankid) {
      this.fuelLevelHistory = this.fuelLevelHistory[reportItem.tankid];
    }
    if (!Array.isArray(this.refuelHistory) && reportItem.tankid) {
      this.refuelHistory = this.refuelHistory[reportItem.tankid];
    }
    this.schema.content[1].ref.draw(
      {
        data: [this.fuelLevelHistory],
        axis: 0,
        reqTime: Date.now(),
        priority: Date.now(),
      },
      {
        xDomainValue: [starttime, endtime],
        shapes: getShapes(),
      }
    );
  };

  bulkReqTracker(apis, handleResponse);
};

const getFuelValue = (value) => {
  let tankCapacity = _.get(this.selectedVehicle, "data.fueltankcapacity");
  if (_.get(this.selectedVehicle, "data.vehicleModel.fueltype") === "EV") {
    tankCapacity = tankCapacity ? tankCapacity : 100;
  }
  tankCapacity = parseInt(tankCapacity);
  return (
    value + "%, " + parseFloat((value / 100) * tankCapacity).toFixed(1) + " L"
  );
};

const tankColumnShowable = (vh) => {
  let check = (v) => _.get(v, "data.vehiclemeta.numfueltanks", 1) > 1;
  return Array.isArray(vh) ? vh.map(check).includes(true) : check(vh);
};

const download = (schema, data, store) => {
  // mixpanel.track("User Downloads Pilferage Report", {
  //   Platform: "Web",
  //   Application: "Web",
  //   Screen: "Report",
  // });
  let strictColumns =
    store.groupTree.children.filter((g) => (g.path || "").indexOf("1259") > -1)
      .length > 0; // kushalsslp
  if (this.finalData) {
    let finalData = _.map(this.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      if (strictColumns) {
        r.location = stripLoc(r.location);
      }
      return r;
    });
    if (strictColumns) {
      finalData = _.map(finalData, (r) => {
        let headings = schema.content[0].head
          .filter((c) => (c.isShowable ? c.isShowable(data.vehicle) : true))
          .map((c) => c.key);
        return _.pick(r, headings);
      });
    }
    JSONToCSVConvertor(finalData, "PilferageReport", false);
  }
};

const schema = {
  key: "pilferage_report",
  name: "Pilferage",
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Pilferage Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 7,
        left: 0,
        top: 0,
      },
      onItemClick,
      head: [
        { key: "vehicleno", name: "", name: "Vehicle No" },
        { key: "model", name: "", name: "Model" },
        {
          key: "starttime",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
        },
        { key: "endtime", name: "End Time", type: "DATE", format: dateFormat },
        { key: "tankid", name: "Tank ID", isShowable: tankColumnShowable },
        { key: "pilferageLitres", name: "Pilferage (ltr)" },
        { key: "fuelprice", name: "Fuel Price (₹)" },
        {
          key: "location",
          name: "Location",
          width: 3,
          onClick: (d, item) => {
            window.showInGoogleMaps(item.latLngArr[0], item.latLngArr[1]);
          },
        },
      ],
    },
    {
      key: "fuellevel",
      type: schemaTypes.IN_GRAPH,
      graphType: "graph",
      position: {
        width: 12,
        height: 5,
        left: 0,
        top: 7,
      },
      showTime: true,
      graphSetName: "pilferageGraph",
      background: "#333",
      depAPIs: ["pilferageReport", "getRefuelHistory"],
      config: [
        {
          listenTo: [{ api: "getFuelLevelInfo", key: "value" }],
          color: "#fff",
          name: "Fuel ",
          getValue: getFuelValue,
          unit: "%",
        },
      ],
    },
  ],
};
export default schema;

const clear = () => {
  if (schema.content[1].ref) {
    schema.content[1].ref.draw(
      {
        data: [],
        axis: 0,
        reqTime: Date.now(),
        priority: Date.now(),
      },
      {
        xDomainValue: [0, 0],
        shapes: [],
      }
    );
  }
};

window.refreshPilferageGraph = () => {
  setTimeout(clear, 50);
  setTimeout(clear, 500);
};
